export default function StoreIconA() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={`ef-header-icon-store`}>
            <path
                d="M4.99131 8.93509C5.0385 8.42033 5.47022 8.02637 5.98713 8.02637L18.0545 8.02637C18.5746 8.02637 19.0078 8.42503 19.051 8.94332L19.8844 18.9433C19.9329 19.5263 19.4729 20.0264 18.8878 20.0264H5.07047C4.48214 20.0264 4.02094 19.521 4.07464 18.9351L4.99131 8.93509Z"
                stroke="currentColor"
                strokeWidth="1.6"
            />
            <path d="M15 10.5L15 6.5C15 4.84315 13.6569 3.5 12 3.5C10.3431 3.5 9 4.84315 9 6.5V10.5" stroke="currentColor" strokeWidth="1.6" />
        </svg>
    );
}
